import { Component, Input } from '@angular/core';
import { EaDisplay, EaVariant } from '../pr-display';
import { PrPanelComponent } from '../pr-panel/pr-panel/pr-panel.component';

@Component({
    selector: 'pr-color-panel',
    templateUrl: './pr-color-panel.component.html',
    styleUrls: ['./pr-color-panel.component.scss'],
    standalone: false
})
export class PrColorPanelComponent extends PrPanelComponent {
  @Input() display: EaDisplay = EaDisplay.success;
  @Input() variant: EaVariant = EaVariant.colored;

  constructor() {
    super();
  }
}
